let calculateTaxAmount = (
  quantity,
  unitPrice,
  taxRate,
  taxType,
  tax_per_measurement,
  volume_per_piece,
  pack_quantity,
) => {
  // console.log({
  //   quantity,
  //   unitPrice,
  //   taxRate,
  //   taxType,
  //   tax_per_measurement,
  //   volume_per_piece,
  //   pack_quantity,
  // });
  if (taxType === 'fixed' && tax_per_measurement) {
    return taxRate * volume_per_piece * (pack_quantity * quantity);
  } else if (taxType === "percentage" && tax_per_measurement) {
      if (!unitPrice || unitPrice <= 0) return 0;
    return taxRate * volume_per_piece * (pack_quantity * quantity) / 100;
  }
  return taxType === 'fixed'
    ? taxRate * quantity
    : parseFloat((quantity * unitPrice * taxRate) / 100);

  // return parseFloat((quantity * unitPrice * taxRate) / 100);
};

export default function getOverallTaxDetails(items) {
  // console.log('Calculating overall tax details for items:', items); // Debug log
  let overallTax = [];
  for (let item of items) {
    // console.log({ item });
    let taxInfo = item.tax || item.get_tax || item.taxInfo;
    let taxAmount =
      item.exchanged_tax_amount ||
      item.taxAmount ||
      item.tax_amount ||
      item.invoice_tax ||
      item.salesTax;

    if (!!taxInfo) {
      if (taxInfo.id !== null) {
        // if (typeof taxAmount === 'undefined') {
        // SIQ-1211
        //tax value from bulk item fixed!
        taxAmount =
          calculateTaxAmount(
            item.quantity,
            (item.exchanged_rate ?? item.rate) || item.unitPrice,
            taxInfo.rate,
            taxInfo.type,
            item.tax_per_measurement || item?.item?.tax_per_measurement,
            item.volume_per_piece || item?.item?.volume_per_piece,
            item.pack_quantity || item?.item?.pack_quantity,
          ) || 0;
        // }
        let previousTax = false;
        for (let index in overallTax) {
          if (overallTax[index].id === taxInfo.id) {
            previousTax = true;
            overallTax[index] = {
              ...overallTax[index],
              total: parseFloat(overallTax[index].total + taxAmount),
            };
          }
        }
        if (!previousTax) {
          overallTax.push({
            id: taxInfo.id,
            rate: taxInfo.rate || taxInfo.rate,
            name: taxInfo.name || taxInfo.name,
            total: taxAmount || 0,
            type: taxInfo.type || taxInfo.type,
          });
        }
      }
    }
  }

  return overallTax;
}
